/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderid: NonNullable<unknown> }} Dialog_Delivery_Issue_DescriptionInputs */

const en_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There seems to be an issue delivering your item. To get this resolved quickly for you, please note down this Order ID and contact customer support via the App
Order ID: ${i?.orderid}`)
};

const ar_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدو أن هناك مشكلة في توصيل عنصرك. لحل هذه المشكلة بسرعة، يرجى تدوين معرف الطلب هذا والاتصال بدعم العملاء عبر التطبيق
معرف الطلب: ${i?.orderid}`)
};

const de_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es scheint ein Problem bei der Lieferung Ihres Artikels zu geben. Um dies schnell für Sie zu lösen, notieren Sie bitte diese Bestellnummer und kontaktieren Sie den Kundensupport über die App
Bestellnummer: ${i?.orderid}`)
};

const es_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parece que hay un problema con la entrega de tu artículo. Para solucionarlo rápidamente, anota este ID de pedido y ponte en contacto con el servicio de atención al cliente a través de la app
ID de pedido: ${i?.orderid}`)
};

const fr_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il semblerait qu'il y ait des difficultés lors de la réception de votre article. Afin de résoudre cet incident rapidement, veuillez noter l'identifiant d'achat suivant et contacter l'assistance via l'application.
Identifiant d'achat : ${i?.orderid}`)
};

const it_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sembra che ci sia un problema con la consegna del tuo articolo. Per risolvere rapidamente questo problema, prendi nota di questo ID dell'ordine e contatta il Supporto clienti tramite l'App
ID Ordine: ${i?.orderid}`)
};

const ja_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アイテム送付時にエラーが発生しました。この問題を迅速に解決するため、下記のご注文IDをメモして、アプリからカスタマーサポートにお問い合わせください。
ご注文ID：${i?.orderid}`)
};

const ko_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`아이템을 지급하는 데 문제가 발생한 것 같아요. 신속한 해결을 위해 이 주문 ID를 메모한 뒤 앱을 통해 고객센터로 문의해 주세요.
주문 ID: ${i?.orderid}`)
};

const pt_br_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parece que ocorreu um problema na entrega do seu item. Para que possamos solucionar isso rapidamente, anote o ID do pedido e contate o suporte pelo aplicativo.
ID do pedido: ${i?.orderid}`)
};

const ru_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Возникла проблема с доставкой вашей покупки. Чтобы быстро решить эту проблему, запишите ID этого заказа и обратитесь в службу поддержки клиентов через приложение
ID заказа: ${i?.orderid}`)
};

const th_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดูเหมือนว่าจะมีปัญหาในการส่งมอบไอเท็มของคุณ เพื่อแก้ไขปัญหานี้อย่างรวดเร็ว โปรดจด ID คำสั่งซื้อนี้ไว้และติดต่อฝ่ายสนับสนุนลูกค้าผ่านแอป
ID คำสั่งซื้อ: ${i?.orderid}`)
};

const tr_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ürünün tesliminde bir sorun var gibi görünüyor. Bu sorunun hızlıca çözülmesi için lütfen bu Sipariş Numarasını not al ve uygulama üzerinden Müşteri Hizmetleriyle iletişime geç
Sipariş Numarası: ${i?.orderid}`)
};

const zh_cn_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`商品发送过程出现异常。为尽快协助你，请记录订单编号后，回到 App 联系客服：
订单编号：${i?.orderid}`)
};

const zh_tw_dialog_delivery_issue_description = /** @type {(inputs: Dialog_Delivery_Issue_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`商品發送過程出現異常。為盡快協助你，請紀錄訂單編號後，回到 App 聯繫客服人員
訂單編號：${i?.orderid}`)
};

/**
* | output |
* | --- |
* | "There seems to be an issue delivering your item. To get this resolved quickly for you, please note down this Order ID and contact customer support via the Ap..." |
*
* @param {Dialog_Delivery_Issue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_delivery_issue_description = /** @type {((inputs: Dialog_Delivery_Issue_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delivery_Issue_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_delivery_issue_description(inputs)
	if (locale === "ar") return ar_dialog_delivery_issue_description(inputs)
	if (locale === "de") return de_dialog_delivery_issue_description(inputs)
	if (locale === "es") return es_dialog_delivery_issue_description(inputs)
	if (locale === "fr") return fr_dialog_delivery_issue_description(inputs)
	if (locale === "it") return it_dialog_delivery_issue_description(inputs)
	if (locale === "ja") return ja_dialog_delivery_issue_description(inputs)
	if (locale === "ko") return ko_dialog_delivery_issue_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_delivery_issue_description(inputs)
	if (locale === "ru") return ru_dialog_delivery_issue_description(inputs)
	if (locale === "th") return th_dialog_delivery_issue_description(inputs)
	if (locale === "tr") return tr_dialog_delivery_issue_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_delivery_issue_description(inputs)
	return zh_tw_dialog_delivery_issue_description(inputs)
});